import ISalesProductPrice from "@/interfaces/sales-product-price.interfaces";
import { CustomerSalesProductStatus } from "@/types/customer-sales-product.types";
import { FixedMonthlyFeeType } from "@/types/fixed-monthly-fee-type.types";

import { CustomerSalesProductFormData } from "./types";

export const normalizePlanData = (_plan: ISalesProductPrice): CustomerSalesProductFormData => {
  const normalizedFormData: CustomerSalesProductFormData = {
    salesProductId: _plan.salesProductId,
    salesProductPriceId: _plan.id,
    startDate: new Date(_plan.startDate),
    pricePerEvent: _plan.pricePerEvent,
    eventsIncludedMonthlyFee: _plan.eventsIncludedMonthlyFee,
    feePerSalesConvertion: _plan.feePerSalesConvertion,
    fixedFeePerSalesConvertion: _plan.fixedFeePerSalesConvertion,
    fixedMonthlyFee: _plan.fixedMonthlyFee,
    fixedMonthlyFeeType: FixedMonthlyFeeType.Integral,
    nextMonthlyPayment: new Date(),
    nextPriceUpdate: new Date(),
    dueDay: 1,
    status: CustomerSalesProductStatus.Active,
    externalSubscriptionId: null,
    endDate: new Date(_plan.startDate),
  };

  return normalizedFormData;
};

export const isPlanValid = (plan: ISalesProductPrice) => {
  const currentDate = new Date();
  currentDate.setHours(0, 0, 0, 0);

  const startDate = new Date(plan.startDate);
  startDate.setHours(0, 0, 0, 0);

  const endDate = plan.endDate ? new Date(plan.endDate) : null;
  if (endDate) {
    endDate.setHours(23, 59, 59, 999);
  }

  return startDate <= currentDate && (endDate ? currentDate <= endDate : true);
};
